// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Method to filter out internal properties prefixed by "__"
 */
export const getExternalProps = (props) => {
    const externalProps = {};
    for (const propName in props) {
        if (!propName.startsWith('__')) {
            externalProps[propName] = props[propName];
        }
    }
    return externalProps;
};
//# sourceMappingURL=external-props.js.map